import React, { useEffect, useState } from "react";
import { Card, Row, Col, Table, Form, Button, Spinner, Modal } from "react-bootstrap";
import { GET_CATEGORYS } from "../../apollo/category/query";
import { useLazyQuery } from "@apollo/client";
import { GET_BANKS } from "../../apollo/bank/query";
import { S3_URL } from "../../const";
import { convertCurrency, covertTimeZone, numberFormat } from "../../helper";

export default function BillOfferPriceV3({ shopData, orderGroupData, titleBill, isFromHistoryOfferPrice }) {

    console.log("orderGroupData: ", orderGroupData)
    // states
    const [categories, setCategories] = useState([])
    const [categoriesPrepare, setCategoriesPrepare] = useState(null)
    const [bankAccount, setBankAccount] = useState([])
    const [selectedCategoryId, setSelectedCategoryId] = useState("")
    const [selectedBankIndex, setSelectedBankIndex] = useState(0)
    const [isSelectBankModalOpen, setIsSelectBankModalOpen] = useState(false)

    // apollo client hooks
    const [loadCategoryData, { data: getCategoryData, loading: loadingLoadCategory }] = useLazyQuery(
        GET_CATEGORYS,
        { fetchPolicy: "cache-and-network" }
    );
    const [getBank, { data: getbankData, loading: loadingBanks }] = useLazyQuery(GET_BANKS, { fetchPolicy: "cache-and-network", });


    // useEffect hooks
    useEffect(() => {
        if (getCategoryData) {
            const categoryData = getCategoryData?.categories?.data || [];
            setCategories(categoryData);
            const firstCategory = categoryData[0];
            setCategoriesPrepare(firstCategory);
            setSelectedCategoryId(firstCategory?.id ?? "");
        }
    }, [getCategoryData]);

    useEffect(() => {
        if (getbankData) {
            setBankAccount(getbankData?.banks?.data);
        }
    }, [getbankData]);

    useEffect(() => {
        if (!bankAccount?.length) {
            setSelectedBankIndex(0)
            return
        }
        if (selectedBankIndex >= bankAccount.length) {
            setSelectedBankIndex(0)
        }
    }, [bankAccount, selectedBankIndex])

    useEffect(() => {
        handleFactCategorys()
        _fetchBank()
    }, [shopData])


    // fetch bank datas
    const _fetchBank = async () => {

        try {
            await getBank({
                variables: {
                    limit: 100,
                    orderBy: "createdAt_DESC",
                    where: {
                        shop: shopData?.id,
                        isDeleted: false,
                    },
                },
            });
        } catch (error) {
            console.log(error)
        }
    };
    // functions get catetgories datas
    const handleFactCategorys = async () => {
        let localData = JSON.parse(localStorage.getItem("SHOP_DATA"))
        if (loadingLoadCategory) return
        try {

            await loadCategoryData({
                variables: {
                    limit: null,
                    where: {
                        isDeleted: false,
                        orderBy: "createdAt_DESC",
                        shop: localData?.id,
                    },
                },
            });

        } catch (error) {
            console.log({ error })
        }
    }

    // split catetory and set new data
    const handleChangeCategory = (values) => {
        if (!values) return;
        setSelectedCategoryId(values);
        const category = categories?.find((item) => item?.id === values);
        setCategoriesPrepare(category);
    }

    const orderLists = orderGroupData?.offerprices || orderGroupData?.orders;
    const canSelectBankByQr = shopData?.id === "674532cf47f983007f44748d"
    const selectedBankAccount = canSelectBankByQr
        ? (bankAccount?.[selectedBankIndex] ?? bankAccount?.[0])
        : bankAccount?.[0]
    const printStyles = `
@page {
  size: A4;
  margin: 8mm;
}

@media print {
  html, body {
    width: 210mm;
    height: 297mm;
  }
  body {
    margin: 0 !important;
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }
  .bill-offerprice-v3-print {
    width: 210mm;
    margin: 0 !important;
    padding: 0 !important;
    background: #fff !important;
  }
  .bill-offerprice-v3-print .card {
    border: none !important;
    box-shadow: none !important;
  }
  .bill-offerprice-v3-print .card-header,
  .bill-offerprice-v3-print .card-body {
    padding: 0 !important;
    border: none !important;
  }
  .bill-offerprice-v3-print .no-print {
    display: none !important;
  }
  .bill-offerprice-v3-print .row {
    margin-left: 0 !important;
    margin-right: 0 !important;
  }
  .bill-offerprice-v3-print [class*="col-"],
  .bill-offerprice-v3-print .col {
    padding-left: 6px !important;
    padding-right: 6px !important;
  }
  .bill-offerprice-v3-print table th,
  .bill-offerprice-v3-print table td {
    padding: 4px 6px !important;
    font-size: 11px !important;
  }
  .bill-offerprice-v3-print .avoid-break {
    break-inside: avoid;
    page-break-inside: avoid;
  }
}
`;

console.log(orderLists);

    

    return (
        <div className="bg-white bill-offerprice-v3-print">
            <style>{printStyles}</style>
            <Card className="mx-auto max-w-5xl" style={{ border: 'none' }}>
                <Card.Header className="d-flex justify-content-between align-items-center" style={{ border: 'none' }}>
                    <div />
                    <div className="d-flex align-items-center gap-4">
                        <img
                            src={S3_URL + shopData?.image}
                            alt="Logo"
                            className="object-contain"
                            style={{ width: "auto", height: 80 }}
                        />
                        <div>
                            <h2 className="h4">{titleBill}</h2>
                        </div>
                    </div>
                    <div className="text-end">
                        <Form.Group>
                            <Form.Label>
                                ປະເພດສິນຄ້າ: {categoriesPrepare?.name ?? "-"}
                            </Form.Label>
                            {loadingLoadCategory ? <Spinner animation="border" size="sm" /> : <Form.Control className="no-print" as="select" onChange={(e) => handleChangeCategory(e?.target?.value)} value={selectedCategoryId}>
                                {categories.map((option, _index) => (
                                    <option key={_index} value={option?.id}>{option?.name}</option>
                                ))}
                            </Form.Control>}
                        </Form.Group>

                    </div>
                </Card.Header>
                <Card.Body>
                    <Row className="mb-4">
                        <Col md={6} style={{ lineHeight: 0.5 }}>
                            <h5>{categoriesPrepare?.companyOption ?? "....................."}</h5>
                            <p>{categoriesPrepare?.addressOption ?? "....................."}</p>
                            <p>{categoriesPrepare?.phoneOption ?? "....................."}</p>
                            <p>{categoriesPrepare?.emailOption ?? ""}</p>
                            <p>{categoriesPrepare?.websiteOption ?? ""}</p>
                        </Col>
                        <Col md={6}>
                            <p>ໝາຍເຫດ: {orderGroupData?.note ?? "....................."}</p>
                            <Row>
                                <Col>
                                    <p>ເລກໃບບິນ</p>
                                </Col>
                                <Col>
                                    <p>ວັນທີຈັດສົ່ງ</p>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <h5>{orderGroupData?.code}</h5>
                                </Col>
                                <Col>
                                    <h5>{covertTimeZone(orderGroupData?.createdAt)}</h5>
                                </Col>
                            </Row>

                        </Col>
                    </Row>

                    <div className="w-full space-y-4">
                        {/* Header Section */}
                        <Row className="mb-4">
                            <Col md={6}>
                                <div className="text-sm" style={{lineHeight:0.5}}>
                                    <h6>ຂໍ້ມູນລູກຄ້າ</h6>
                                    <p>ຊື່: {orderGroupData?.userConfirm?.name ?? orderGroupData?.customerName ?? ""} {orderGroupData?.customerLastName ?? ""}</p>
                                    <p>ໄອດີລູກຄ້າ: {orderGroupData?.userConfirm?.userCode ?? ""}</p>
                                    <p>ທີ່ຢູ່ບ້ານ: {orderGroupData?.userConfirm?.address?.village ?? "..."}, ເມືອງ: {orderGroupData?.userConfirm?.address?.district ?? "...."}, ແຂວງ: {orderGroupData?.userConfirm?.address?.province ?? "..."}</p>
                                    <p>ເບີໂທ: {orderGroupData?.userConfirm?.phone ?? ""}</p>
                                </div>
                            </Col>
                            <Col md={6}>
                                <Row>
                                    <Col>
                                        <Form.Group>
                                            <Form.Label>ຮູບແບບການຂາຍ</Form.Label>
                                            <Form.Control className="no-print" as="select" defaultValue="PAY_IN_CASH" style={{ border: 'none' }}>
                                                <option value="PAY_IN_CASH">ຈ່າຍສົດ</option>
                                                <option value="FREE_EXAMPLE">ຟຣີ ແລະ ຕົວຢ່າງ</option>
                                                <option value="CREDIT">ເຄດິດ</option>
                                                <option value="STOCK_BRAND">ສະຕ່ອກແຟນຊາຍ</option>
                                                <option value="STOCK_OTHER">ສະຕ່ອກຕ່າງໆ</option>
                                            </Form.Control>
                                        </Form.Group>
                                    </Col>
                                    <Col>
                                        <Form.Group>
                                            <Form.Label>ຂໍ້ມູນພະນັກງານຂາຍ</Form.Label>
                                            <p>ຊື່: {orderGroupData?.createdBy?.firstName ?? "" ?? orderGroupData?.staff + " " + orderGroupData?.createdBy?.lastName ?? "" ?? orderGroupData?.staffLastname ?? ''}</p>
                                            <p>ໄອດີເຊວ: {orderGroupData?.createdBy?.staffCode ?? ''}</p>
                                        </Form.Group>
                                    </Col>
                                </Row>


                            </Col>
                        </Row>

                        <Row>
                            <Col className="text-center">ວັນທີ່ຈະຈ່າຍເງິນ</Col>
                            <Col className="text-center">ຮູບແບບການຈັດສົ່ງ</Col>
                            <Col className="text-center">ສາຂາ ຫຼື ບ່ອນຈັດສົ່ງ</Col>
                            <Col className="text-center">ສະກຸນເງິນ</Col>
                        </Row>
                        <Row>
                            <Col className="text-center p-2">{covertTimeZone(orderGroupData?.paymentDate)}</Col>
                            <Col className="text-center p-2">
                                {orderGroupData?.deliveryMethod === "DELIVERY_TO" ? "ສົ່ງເຖິງທີ່" :
                                 orderGroupData?.deliveryMethod === "SHIPPING_COMPANY" ? "ບໍລິສັດຂົນສົ່ງ" :
                                 orderGroupData?.deliveryMethod === "OVERSEAS_DELIVERY" ? "ສົ່ງຕ່າງປະເທດ" :
                                 orderGroupData?.deliveryMethod === "PICKUP" ? "ມາຮັບເຄື່ອງເອງ" :
                                 orderGroupData?.deliveryMethod}
                            </Col>
                            <Col className="text-center p-2">{orderGroupData?.addressCf ?? "................"}</Col>
                            <Col className="text-center p-2">{orderGroupData?.currency ?? "................"}</Col>
                        </Row>

                        {/* Main Table */}
                        <Table bordered hover className="mt-2">
                            <thead>
                                <tr>
                                    <th className="text-center">NO</th>
                                    <th className="text-center">ເລກລອດ</th>
                                    <th className="text-center">ຊື່ສິນຄ້າ</th>
                                    <th className="text-center">ຫົວໜ່ວຍ</th>
                                    {/* <th className="text-center">ຂໍ້ມູນຈຳເພາະ</th> */}
                                    <th className="text-center">ຈຳນວນຂາຍ</th>
                                    <th className="text-center">ແຖມ</th>
                                    <th className="text-center">ລາຄາ</th>
                                    <th className="text-center">ຈຳນວນເງິນ</th>
                                    {isFromHistoryOfferPrice ? (
                                        <th className="text-center">ໝາຍເຫດ</th>
                                    ) : null}
                                </tr>
                            </thead>
                            <tbody>
                                {orderLists.map((row, _index) => (
                                    <>
                                        <tr key={row?.id}>
                                            <td className="text-center">{_index + 1}</td>
                                            <td>{row?.stock?.survivalId?.survivalNumber ?? "-"}</td>
                                            <td>{row?.productName}</td>
                                            <td>{row?.stock?.unitId?.name ?? "-"}</td>
                                            <td>{row?.amount ?? 0}</td>
                                            <td>{row?.amountFree ?? 0}</td>
                                            <td>{convertCurrency(row?.currency ?? "ກີບ")}{numberFormat(row?.price)} </td>
                                            <td>{convertCurrency(row?.currency ?? "ກີບ")}{numberFormat(row?.totalPrice ?? 0)}</td>
                                            {isFromHistoryOfferPrice ? (
                                                <td>{row?.note ?? "-"}</td>
                                            ) : null}
                                        </tr>
                                        {(row?.children || []).map((child, cIdx) => (
                                            <tr key={(child?.id ?? `${row?.id}-child-${cIdx}`)}>
                                                <td className="text-center"></td>
                                                <td>{child?.stock?.survivalId?.survivalNumber ?? "-"}</td>
                                                <td>
                                                    {"↳ "}{child?.productName ?? child?.stock?.name}
                                                    {String(child?.tag || child?.saleTag || "").toUpperCase() === "FREE" ? " (ແຖມ)" : ""}
                                                </td>
                                                <td>{child?.stock?.unitId?.name ?? "-"}</td>
                                                <td>{child?.amount ?? 0}</td>
                                                <td>{convertCurrency(child?.currency ?? row?.currency ?? "ກີບ")}{numberFormat(0)}</td>
                                                <td>{convertCurrency(child?.currency ?? row?.currency ?? "ກີບ")}{numberFormat(0)}</td>
                                                {isFromHistoryOfferPrice ? <td /> : null}
                                            </tr>
                                        ))}
                                    </>
                                ))}
                            </tbody>
                        </Table>

                        {/* Footer Section */}
                        <Row className="mt-4 avoid-break">
                            <Col md={8}>
                                <div className="space-y-2">
                                    <p className="font-medium">ບັນຊີທະນາຄານ:</p>
                                    <p style={{ marginTop: -8 }}>ຊື່ບັນຊີ: {selectedBankAccount?.bankUser ?? "-"}</p>
                                    <div className="d-flex justify-content-between align-items-start" style={{ gap: 16 }}>
                                        <div className="d-flex gap-1" style={{ flex: 1, minWidth: 0 }}>
                                            <div className="pl-4 space-y-1 " style={{ lineHeight: 0.5 }}>
                                                {bankAccount?.map((bank, _index) => (
                                                    <p
                                                        key={bank?.id}
                                                        style={{
                                                            fontWeight: canSelectBankByQr && _index === selectedBankIndex ? 700 : undefined,
                                                        }}
                                                    >
                                                        ເລກບັນຊີທີ {_index + 1}: {" "} {bank?.bankAccount ?? "-"}
                                                    </p>
                                                ))}
                                            </div>
                                        </div>
                                        <div
                                            style={{
                                                border: '1px solid gray',
                                                width: 200,
                                                height: 130,
                                                cursor: canSelectBankByQr ? 'pointer' : undefined,
                                                flexShrink: 0,
                                            }}
                                            onClick={() => {
                                                if (!canSelectBankByQr) return
                                                if (!bankAccount?.length) return
                                                setIsSelectBankModalOpen(true)
                                            }}
                                        >
                                            <img src={S3_URL + selectedBankAccount?.image} style={{ width: '100%', height: '100%', objectFit: 'contain' }} />
                                        </div>
                                    </div>
                                </div>
                            </Col>
                            <Col md={4}>
                                <div className="space-y-2">
                                    <div className="d-flex justify-content-between">
                                        <span>ລວມເປັນເງິນ</span>
                                        <span className="font-medium">{numberFormat(orderGroupData?.totalPrice)} ₭</span>
                                    </div>
                                    <div className="d-flex justify-content-between">
                                        <span></span>
                                        <span className="font-medium">{numberFormat(orderGroupData?.sumPriceBaht)} ฿</span>
                                    </div>
                                    <div className="d-flex justify-content-between">
                                        <span></span>
                                        <span className="font-medium">{numberFormat(orderGroupData?.sumPriceUsd)} $</span>
                                    </div>
                                    {orderGroupData?.discountAmountApplied > 0 && (
                                        <div className="d-flex justify-content-between">
                                            <span>ສ່ວນຫຼຸດ {orderGroupData?.discountType ? "" : `(${orderGroupData?.discount ?? 0}%)`}</span>
                                            <span className="font-medium">-{numberFormat(orderGroupData?.discountAmountApplied)} ₭</span>
                                        </div>
                                    )}
                                    {orderGroupData?.taxes?.taxStatus && orderGroupData?.taxes?.taxAmount > 0 && shopData?.id === "674532cf47f983007f44748d" && (
                                        <div className="d-flex justify-content-between">
                                            <span>ຍອດເງິນບໍ່ລວມອາກອນ</span>
                                            <span className="font-medium">{numberFormat(orderGroupData?.taxes?.priceBeforeTax)} ₭</span>
                                        </div>
                                    )}
                                    {orderGroupData?.taxes?.taxStatus && orderGroupData?.taxes?.taxAmount > 0 && (
                                        <div className="d-flex justify-content-between">
                                            <span>ອາກອນ ({orderGroupData?.taxes?.tax}{orderGroupData?.taxes?.taxType === "PERCENT" ? "%" : "₭"})</span>
                                            <span className="font-medium">+{numberFormat(orderGroupData?.taxes?.taxAmount)} ₭</span>
                                        </div>
                                    )}
                                    <div className="d-flex justify-content-between">
                                        <span>{orderGroupData?.costTitle ?? "ຄ່າຂົນສົ່ງ"}</span>
                                        <span className="font-medium">{numberFormat(orderGroupData?.shippingCost ?? 0)} ₭</span>
                                    </div>
                                    <div className="d-flex justify-content-between font-weight-bold">
                                        <h5>ຈຳນວນເງິນທີ່ຕ້ອງຈ່າຍ</h5>
                                        <h5>{numberFormat(orderGroupData?.sumPrice ?? 0)} {convertCurrency(orderGroupData?.currency)}</h5>
                                    </div>
                                </div>
                            </Col>
                        </Row>

                        <div className="text-center italic mt-4">
                            Thank you for trusting our company!! ຂອບໃຈທີ່ໄວ້ວາງໃຈໃຫ້ບໍລິການຈາກພວກເຮົາ!!
                        </div>
                    </div>

                    <Row className="pt-4 avoid-break">
                        <Col className="text-center">
                            <p>Inspector's Signature <br /> ລາຍເຊັນຜູ້ກວດກາ</p>
                            <div style={{ height: 70 }} />
                            <p>Date/ວັນທີ:</p>
                        </Col>
                        <Col className="text-center">
                            <p>Recipient Signature <br /> ລາຍເຊັນຜູ້ຮັບ</p>
                            <div style={{ height: 70 }} />
                            <p>Date/ວັນທີ:</p>
                        </Col>
                        <Col className="text-center">
                            <p>Delivery Person Signature <br /> ລາຍເຊັນຜູ້ສົ່ງ</p>
                            <div style={{ height: 70 }} />
                            <p>Date/ວັນທີ:</p>
                        </Col>
                        <Col className="text-center">
                            <p>Payee's Signature <br /> ລາຍເຊັນຜູ້ຮັບເງິນ</p>
                            <div style={{ height: 70 }} />
                            <p>Date/ວັນທີ:</p>
                        </Col>
                    </Row>

                    {canSelectBankByQr ? (
                        <Modal
                            show={isSelectBankModalOpen}
                            onHide={() => setIsSelectBankModalOpen(false)}
                            centered
                            size="lg"
                        >
                            <Modal.Header closeButton>
                                <Modal.Title>ເລືອກບັນຊີທະນາຄານ</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <div className="d-flex gap-3 flex-wrap">
                                    {bankAccount?.map((bank, _index) => (
                                        <div
                                            key={bank?.id ?? _index}
                                            style={{
                                                border: _index === selectedBankIndex ? '2px solid #2563eb' : '1px solid #d2d2d2',
                                                width: 220,
                                                padding: 10,
                                                cursor: 'pointer',
                                            }}
                                            onClick={() => {
                                                setSelectedBankIndex(_index)
                                                setIsSelectBankModalOpen(false)
                                            }}
                                        >
                                            <div style={{ border: '1px solid #d2d2d2', width: '100%', height: 160 }}>
                                                <img
                                                    src={S3_URL + bank?.image}
                                                    style={{ width: '100%', height: '100%', objectFit: 'contain' }}
                                                />
                                            </div>
                                            <div style={{ marginTop: 8, fontSize: 14, lineHeight: 1.2 }}>
                                                <div style={{ fontWeight: 700 }}>{bank?.bankName ?? "-"}</div>
                                                <div>{bank?.bankAccount ?? "-"}</div>
                                                <div>{bank?.bankUser ?? "-"}</div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </Modal.Body>
                            <Modal.Footer>
                                <Button variant="secondary" onClick={() => setIsSelectBankModalOpen(false)}>
                                    Close
                                </Button>
                            </Modal.Footer>
                        </Modal>
                    ) : null}
                </Card.Body>
            </Card>
        </div>
    );
}


const syleBorder = {
    border: '1px solid #ccc',
}

